import React, { useEffect } from 'react';
import { LongSteelMvpContent, LongSteelMvpImg } from './styles';
import ModalGIF from '../../assets/images/longsteel_purchase_mvp/modal_purchase_longSteel.gif';
import { ERoutes } from '../../routes';
import { useHistory } from 'react-router-dom';
import { GmaisModal } from '../GmaisModal';

export interface PurchaseLongoSteelMvpProps {
  onCloseModal: (neverShowAgain: boolean) => void;
  dontShowThisAgain: () => Promise<void>;
}

export const PurchaseLongoSteelMvpModal = ({
  onCloseModal,
  dontShowThisAgain
}: PurchaseLongoSteelMvpProps) => {
  const history = useHistory();

  function navigateToOrder() {
    history.push(ERoutes.PURCHASE);
  }

  function closeModal(neverShowAgain: boolean) {
    onCloseModal(neverShowAgain);
  }

  return (
    <GmaisModal
      dontShowAgainCheckBox={true}
      dontShowThisAgain={dontShowThisAgain}
      buttons={{
        action: {
          title: 'Acessar a experiência',
          callback: navigateToOrder
        },
        close: {
          title: 'Fechar',
          callback: closeModal
        }
      }}
      title={'Acesse a nova experiência de compra'}
      onDismissModal={() => {
        closeModal(false);
      }}
    >
      <LongSteelMvpContent>
        <div>
          Confira <strong>preços, prazos</strong> estimados de entrega de
          produtos e outras novidades que facilitarão seus pedidos de Aços
          Longos.
          <br />
          <br />
          <LongSteelMvpImg src={ModalGIF} />
        </div>
      </LongSteelMvpContent>
    </GmaisModal>
  );
};
